'use strict';

/**
 * EventLogger class
 *
 * EventLogger logs events targeted at specific elements on the site, such as important links and buttons.
 *
 * @author Teppo Koivula / Avoine Oy (teppo.koivula@avoine.fi)
 */
class EventLogger {

	/**
	 * Constructor method
	 */
	constructor() {
		this.initEvents();
	}

	/**
	 * Attach event listeners
	 */
	initEvents() {

		// Cards
		$('#js-cards')
			.on('click', '.js-toggle-details', function() {
				if ($(this).attr('aria-expanded') == 'false' || $(this).data('event')) return;
				const $card = $(this).parents('.js-card:first');
				const eventData = {
					hitType: 'event',
					eventCategory: 'Liittokortit',
					eventAction: 'Kortin avaus',
					eventLabel: $card.data('title')
				};
				$(this).data('event', true);
				ga('send', eventData);
			})
			.on('click', '.js-details a.button', function() {
				if ($(this).data('event')) return;
				const $card = $(this).parents('.js-card:first');
				const eventData = {
					hitType: 'event',
					eventCategory: 'Liittokortit',
					eventAction: 'Liittolinkin klikkaus',
					eventLabel: $(this).attr('href')
				};
				$(this).data('event', true);
				ga('send', eventData);
			});

		// Forms
		// Note: additional form related logging can be found from the form-builder template file!
		$('.js-form-link').on('click', function() {
			if ($(this).data('event')) return;
			const eventData = {
				hitType: 'event',
				eventCategory: 'Lomakkeet',
				eventAction: 'Lomakelinkin klikkaus',
				eventLabel: $(this).data('label')
			};
			$(this).data('event', true);
			ga('send', eventData);
		});

		// Search
		$('#js-search-form')
			.on('click', '.js-search-main-industry', function() {
				if ($(this).data('event')) return;
				const eventData = {
					hitType: 'event',
					eventCategory: 'Haut',
					eventAction: 'Toimialahaku',
					eventLabel: $(this).text().trim()
				};
				$(this).data('event', true);
				ga('send', eventData);
			})
			.on('click', '.js-search-suggestion', function() {
				if ($(this).data('event')) return;
				const eventData = {
					hitType: 'event',
					eventCategory: 'Haut',
					eventAction: 'Yrityshaku',
					eventLabel: $('#employer_search').data('label')
				};
				$(this).data('event', true);
				ga('send', eventData);
			});

		// sak.fi
		$('a[href^="https://www.sak.fi').on('click', function() {
			if ($(this).data('event')) return;
			const eventData = {
				hitType: 'event',
				eventCategory: 'SAK-linkit',
				eventAction: 'SAK-linkin klikkaus',
				eventLabel: $(this).attr('href')
			};
			$(this).data('event', true);
			ga('send', eventData);
		});
	}

}
